import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgActionTest = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path fill="#88827E" d="M16 17v1H8v-1l3-5h2l3 5Z" />
    <path
      fill="#88827E"
      fillRule="evenodd"
      d="M17 2v2h-1v5.976L21.005 18v3.997H3V18l5-8.024V4l-1 .001V2h10Zm-7 2.001v6.027L5 18v1.995h14V18l-5-7.972V4.001h-4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgActionTest;
